// 自由项相关处理
import {FreeItemsProcessor} from '../domain/retail/freeItem/FreeItemsProcessor'
/**批号拆分处理 */
import {BatchSplitProcessorBlock} from '../domain/retail/batch/BatchSplitProcessorBlock'
/**零售价改变，计算价税额 */
import {RetailPriceChangeProcessor} from '../domain/retail/priceAmount/RetailPriceChangeProcessor'
/**合并明细重复行 */
import {MergeDetailsProcessorBlock} from '../domain/retail/MergeDetailsProcessorBlock'
/**处理明细的编码 */
import {DetailCodeProcessor} from '../domain/retail/DetailCodeProcessor';
/**计算表头概要 */
import {SummaryProcessorBlock} from '../domain/retail/summary/SummaryProcessorBlock';
/**单品打折 */
import {RunSinglePromotionProcessBlock} from '../domain/retail/promotion/RunSinglePromotionProcessBlock';
import {QuantityChangeProcessorBlock} from '../domain/retail/quantity/QuantityChangeProcessorBlock';


const controllerLogList = [FreeItemsProcessor,BatchSplitProcessorBlock,RetailPriceChangeProcessor,
    MergeDetailsProcessorBlock,DetailCodeProcessor,SummaryProcessorBlock,
    QuantityChangeProcessorBlock,RunSinglePromotionProcessBlock];
export {controllerLogList}